import { WatcherFunction } from '..'
import { watchFetchAdAccountsRequest } from './fetchAdAccounts'
import { watchMediaTransferRequest } from './mediaTransfer'

export const facebookAdsSagas: ReadonlyArray<WatcherFunction> = [
  watchFetchAdAccountsRequest,
  watchMediaTransferRequest,
]
